export default __webpack_public_path__ + "static/media/edit.3c70b537.svg";